import React from 'react';
import dashboard from "../assets/svgs/icon.svg";

const InsightCard = ({heading, price, bgColor}) => {
  return (
    <div>
         <div className="flex flex-col justify-start gap-2">
         <div className={`${bgColor} flex justify-center items-center h-[50px] w-[50px] rounded-md`}>
          <img src={dashboard} alt='icon' />
         {/* <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.25 26.25V13.75H26.25V26.25H16.25ZM3.75 16.25V3.75H13.75V16.25H3.75ZM11.25 13.75V6.25H6.25V13.75H11.25ZM3.75 26.25V18.75H13.75V26.25H3.75ZM6.25 23.75H11.25V21.25H6.25V23.75ZM18.75 23.75H23.75V16.25H18.75V23.75ZM16.25 3.75H26.25V11.25H16.25V3.75ZM18.75 6.25V8.75H23.75V6.25H18.75Z" fill="white"/>
</svg> */}

         </div>
         <h1 className="heading-one">{price}</h1>
         <p className="text-regular !text-base">{heading}</p>
        </div>
    </div>
  )
}

export default InsightCard